/*********
This is the crux of our application.

Yes, we can make a chart and show growth, but how do we make this useful?

Staking Tools:
- Epoch reward breakdown
  This could look up fiat price at end of each epoch so users can report their taxes

- Stake account health
  Highlight uptime, decentralization issues, recommend moving to other validators

- Performance history
  Chart the performance of each account in SOL and USD

- Delegate stake
  Need a nice 'validator selection' tool. Allow delegating new stake, highlight
  good small performers and Solana Compass too

- Deactivate Stake
  Allow users to deactivate their stake and get their funds back. Would be cool to allow
  a partial deactivation, using split stake and deactivating the split percentage. I envisage
  a range slider for this.

- Split stake.. and merge?

- Show stake lockup


*********/
<template>
  <div class="stake-account">
    <div :class="{'card dash1 dash1-card': stake, 'card bg-gradient-warning': !stake}">
<!--      <div class="card-header">
        <small><i class="fas fa-wallet"></i> {{ account.pubkey }}</small>
      </div>-->
      <div class="card-body">
<!--        <div class="badge bg float-right"
             :title="'Stake account locked until '+  meta.lockup.unixTimestamp + ' by ' + meta.lockup.custodian "
             v-if="meta.lockup.unixTimestamp > (Date.now()/1000)">Locked</div>

        <h3>Stake: {{ stake.delegation.stake / 1E9 }} SOL</h3>
        <p>Validator: {{ stake.delegation.voter }}</p>
        <p>Since: {{ stake.delegation.activationEpoch }}</p>
        <p>Staker: {{ meta.authorized.staker }}</p>
        <p>Withdrawer: {{ meta.authorized.withdrawer }}</p>-->

        <div class="row">
            <div><img :src="validator.logo" width="25"></div>
          <div class="col">
            <h5>Validator</h5>
            <h5> {{ validator.name }}</h5>
          </div>
          <div class="col" v-if="stake">

            <h5>Stake</h5>
            <h4>{{ stake.delegation?.stake / 1E9 }} SOL</h4>
            <small>${{ stake.delegation?.stake /1E9 * 69}}</small>
          </div>
          <div class="col" v-else>
            <h5>Inactive Stake</h5>
            <h4>{{ account.account.lamports /1e9 }} SOL</h4>
          </div>
          <div class="col">
            <h5>APY</h5>
            <h4>{{ validator.apy }}%</h4>
          </div>
          <div class="col">
            <h5>Actions</h5>
            <div class="dropdown">
              <button type="button" class="btn btn-info dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="fe fe-Calendar me-2"></i>Actions </button>
              <div class="dropdown-menu" style="">
                <a class="dropdown-item" href="javascript:void(0)">Deactivate Stake</a>
                <a class="dropdown-item" href="javascript:void(0)">Split Stake</a>
              </div>
            </div>
          </div>
        </div>

      </div>


    </div>
  </div>
</template>

<script>
import { Connection } from '@solana/web3.js'
const connection = new Connection('https://solana-api.projectserum.com/', {
  commitment: 'confirmed',
  confirmTransactionInitialTimeout: 120000
});

export default {
  name: "StakeAccount",
  props: {
    account: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      rewards: [],
      info: {},
      stake: {},
      meta: {},
      // should pass in via props as an array or individual validator
      validator: {
        name: 'Solana Compass 🧭 solanacompass.com',
        logo: 'https://s3.amazonaws.com/keybase_processed_uploads/fc001db11cfd87be1f705425ffdda705_360_360.jpg',
        apy: 6.32,
        url: 'https://solanacompass.com',
        description: 'Solana Compass is a community-driven, open-source, decentralized, and self-sustaining network that provides a trusted, reliable, and secure network for the development of decentralized applications.',
        health: [
            'HighStake',
            'GeoFocused',
            'Delinquent',

        ],
        commission: 4
      }
    }
  },
  mounted() {
    this.info = this.account.account.data.parsed.info;
     this.stake = this.account.account.data.parsed.info.stake;
     this.meta = this.account.account.data.parsed.info.meta;
  },
  methods: {
    getRewards() {
      // connection.getInflationReward(this.account.pub)
    }
  }
}
</script>

<style scoped>

</style>